import React from "react";

export const SvgArrowUp = (props) => {
	return (
		<svg
			width="12"
			height="8"
			viewBox="0 0 12 8"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M5.50855 0.859575C5.706 0.859575 5.90343 0.934966 6.05396 1.08543L10.7911 5.82259C11.0924 6.12394 11.0924 6.61251 10.7911 6.91373C10.4899 7.21495 10.0014 7.21495 9.70002 6.91373L5.50855 2.72203L1.31707 6.91359C1.01572 7.21481 0.527295 7.21481 0.226099 6.91359C-0.0753899 6.61237 -0.0753899 6.12379 0.226099 5.82245L4.96314 1.08528C5.11375 0.934794 5.31118 0.859575 5.50855 0.859575Z"
				fill="#333333"
			/>
		</svg>
	);
};
